import {ExpandMore} from '@mui/icons-material';
import {Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography} from '@mui/material';
import {SessionQuestion} from '@cp/model';

interface QuestionReviewQuestionSummaryTopicProps {
  question: SessionQuestion;
}

export default function QuestionReviewQuestionSummaryTopic({question}: QuestionReviewQuestionSummaryTopicProps) {
  // Parse the topic string to get structured topic information
  const topicInfo = question.moduleTopic;

  const handleAccordionChange = (event: React.SyntheticEvent) => {
    // Prevent event propagation to parent accordion
    event.stopPropagation();
  };

  return (
    <Accordion
      onChange={handleAccordionChange}
      sx={{
        boxShadow: 'none',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        onClick={handleAccordionChange}
        sx={{
          px: {xs: 1, sm: 2},
          py: {xs: 0.5, sm: 1},
          minHeight: 'auto',
          '&.Mui-expanded': {
            minHeight: 'auto',
          },
          '& .MuiAccordionSummary-content': {
            margin: 0,
            '&.Mui-expanded': {
              margin: 0,
            },
          },
        }}
      >
        <Typography variant="body2" color="text.secondary" sx={{fontWeight: 500}}>
          Topic: {`${topicInfo.category} > ${topicInfo.topic}`}
        </Typography>
      </AccordionSummary>

      <AccordionDetails sx={{px: {xs: 1, sm: 2}, py: {xs: 1, sm: 1.5}}}>
        <Stack spacing={1}>
          {/* Detail */}
          {topicInfo.detail && (
            <Box>
              <Typography variant="caption" color="text.secondary" sx={{fontWeight: 500, display: 'block', mb: 0.5}}>
                Detail:
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  lineHeight: 1.4,
                  wordBreak: 'break-word',
                }}
              >
                {topicInfo.detail}
              </Typography>
            </Box>
          )}

          {/* Show message if no additional details */}
          {!topicInfo.topic && !topicInfo.detail && (
            <Typography variant="body2" color="text.secondary" sx={{fontStyle: 'italic'}}>
              No additional topic details available
            </Typography>
          )}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
